import { useState } from 'react'
import { useCartStore } from '../stores/cartStore'
import CartDrawer from './CartDrawer'

function CartButton() {
  const [isOpen, setIsOpen] = useState(false)
  const itemCount = useCartStore((state) => state.getItemCount())

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="fixed top-4 right-4 z-40 btn-primary shadow-lg flex items-center gap-2"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
          />
        </svg>
        <span>Keranjang</span>
        {itemCount > 0 && (
          <span className="bg-white text-primary rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold">
            {itemCount}
          </span>
        )}
      </button>

      <CartDrawer isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  )
}

export default CartButton
